(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["teeblessed-main-menu"] && !Shopify.designMode) return;
  try {
    if (!window.__teeblessedNavigationBound) {
    window.__teeblessedNavigationBound = true;

    const megaMenu = document.getElementById('TeeblessedShopMegaMenu');
    const navBar = megaMenu?.closest('.teeblessed-nav-bar');
    const headerWrapper = megaMenu?.closest('.header-wrapper');
    const shopDetails = megaMenu?.closest('.teeblessed-nav__details');
    const shopSummary = shopDetails?.querySelector('summary');
    const desktopHoverQuery = window.matchMedia('(hover: hover) and (pointer: fine)');
    let megaMenuPositionFrame = 0;
    let megaMenuCloseTimer = 0;

    const syncMegaMenuPosition = () => {
      if (!megaMenu || !headerWrapper || window.innerWidth < 990) {
        megaMenu?.style.removeProperty('--teeblessed-nav-mega-top');
        return;
      }

      const headerBottom = Math.max(0, Math.min(window.innerHeight, Math.ceil(headerWrapper.getBoundingClientRect().bottom)));
      megaMenu.style.setProperty('--teeblessed-nav-mega-top', `${headerBottom}px`);
    };

    const scheduleMegaMenuPosition = () => {
      window.cancelAnimationFrame(megaMenuPositionFrame);
      megaMenuPositionFrame = window.requestAnimationFrame(syncMegaMenuPosition);
    };

    scheduleMegaMenuPosition();
    window.addEventListener('load', scheduleMegaMenuPosition);
    window.addEventListener('resize', scheduleMegaMenuPosition);
    window.addEventListener('scroll', scheduleMegaMenuPosition, { passive: true });
    navBar?.addEventListener('mouseenter', scheduleMegaMenuPosition);
    navBar?.addEventListener('focusin', scheduleMegaMenuPosition);

    const cancelDesktopShopMenuClose = () => {
      window.clearTimeout(megaMenuCloseTimer);
      megaMenuCloseTimer = 0;
    };

    const openDesktopShopMenu = () => {
      if (!desktopHoverQuery.matches || !shopDetails) return;
      cancelDesktopShopMenuClose();
      shopDetails.setAttribute('open', '');
      scheduleMegaMenuPosition();
    };

    const closeDesktopShopMenu = () => {
      cancelDesktopShopMenuClose();
      if (!desktopHoverQuery.matches || !shopDetails) return;

      megaMenuCloseTimer = window.setTimeout(() => {
        megaMenuCloseTimer = 0;

        if (
          !shopDetails.matches(':hover') &&
          !megaMenu?.matches(':hover') &&
          !shopDetails.matches(':focus-within')
        ) {
          shopDetails.removeAttribute('open');
        }
      }, 250);
    };

    shopDetails?.addEventListener('mouseenter', openDesktopShopMenu);
    shopDetails?.addEventListener('mouseleave', closeDesktopShopMenu);
    megaMenu?.addEventListener('mouseenter', openDesktopShopMenu);
    megaMenu?.addEventListener('mouseleave', closeDesktopShopMenu);
    shopDetails?.addEventListener('focusin', openDesktopShopMenu);
    shopDetails?.addEventListener('focusout', (event) => {
      if (!shopDetails.contains(event.relatedTarget)) {
        shopDetails.removeAttribute('open');
      }
    });
    shopSummary?.addEventListener('click', (event) => {
      if (!desktopHoverQuery.matches) return;
      event.preventDefault();
      openDesktopShopMenu();
    });

    if ('ResizeObserver' in window && headerWrapper) {
      const headerObserver = new ResizeObserver(scheduleMegaMenuPosition);
      headerObserver.observe(headerWrapper);
    }

    document.addEventListener('click', (event) => {
      document.querySelectorAll('.teeblessed-nav__details[open]').forEach((details) => {
        if (!details.contains(event.target)) {
          cancelDesktopShopMenuClose();
          details.removeAttribute('open');
        }
      });
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;

      document.querySelectorAll('.teeblessed-nav__details[open]').forEach((details) => {
        cancelDesktopShopMenuClose();
        details.removeAttribute('open');
        details.querySelector('summary')?.focus();
      });
    });
  }
  } catch(e) { console.error(e); }
})();

})();
